<template>

    <form @submit.prevent="armazenar">

        <button type="button" class="btn btn-success btn-xs" @click="exibeForm = true">
            <i class="fa fa-plus"></i> Adicionar pessoa
        </button>

        <br>
        <br>

        <div class="block" v-if="exibeForm">
            <div class="block-title">
                <h3>Adicionar pessoa</h3>
            </div>

            <div class="row">

                <div class="col-xs-6 col-sm-4">
                    <div class="form-group">
                        <div class="radio">
                                <label class="switch switch-success"><input type="checkbox" v-model="pessoa.remetente"><span></span></label>&nbsp;Remetente

                        </div>
                    </div>
                </div>

                <div class="col-xs-6">
                    <div class="form-group">
                        <div class="radio">
                            <label class="switch switch-success"><input type="checkbox" v-model="pessoa.proprietarioArrendatario"><span></span></label>&nbsp;Proprietário / Arrendatário
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group" :class="{'has-error': errors.has('tipo')}">
                        <label>Tipo</label>
                        <v-select v-model="pessoa.tipo"
                                  :options="[{label: 'Físico', value: '1'}, {label: 'Jurídico', value: '2'}]"
                                  v-validate="'required'" data-vv-name="tipo"></v-select>
                    </div>
                </div>

                <div v-if="pessoa.tipo != null && parseInt(pessoa.tipo.value) == 1">
                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('nome')}">
                            <label>Nome</label>
                            <input type="text" class="form-control" v-model="pessoa.nome" v-validate="'required'"
                                   data-vv-name="nome"/>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <div class="form-group">
                            <label>CPF</label>
                            <the-mask :mask="'###.###.###-##'" type="text" :masked="true" v-model="pessoa.cpf"
                                      class="form-control" @input="verificaJaCadastrado('cpf')"></the-mask>
                        </div>
                    </div>
                </div>

                <div v-if="pessoa.tipo != null && parseInt(pessoa.tipo.value) == 2">
                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('razao_social')}">
                            <label>Razão social</label>
                            <input type="text" class="form-control" v-model="pessoa.razao_social"
                                   v-validate="'required'" data-vv-name="razao_social"/>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <div class="form-group">
                            <label>Fantasia</label>
                            <input type="text" class="form-control" v-model="pessoa.fantasia" data-vv-name="fantasia"/>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-4">
                        <div class="form-group">
                            <label>CNPJ</label>
                            <the-mask mask="##.###.###/####-##" type="text" :masked="true" v-model="pessoa.cnpj"
                                      class="form-control" @input="verificaJaCadastrado('cnpj')"></the-mask>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Telefone</label>
                        <the-mask :mask="['(##) ####-####', '(##) #####-####']" :masked="true" v-model="pessoa.fone"
                                  data-vv-name="fone" class="form-control"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Telefone 2</label>
                        <the-mask :mask="['(##) ####-####', '(##) #####-####']" :masked="true" v-model="pessoa.fone2"
                                  data-vv-name="fone" class="form-control"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>CEP</label>
                        <the-mask :mask="['##.###-###']" :masked="true" v-model="pessoa.cep" @blur.native="consultaCep"
                                  data-vv-name="cep" class="form-control"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Endereço</label>
                        <input type="text" class="form-control" v-model="pessoa.endereco"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Número</label>
                        <the-mask :mask="['########']" :masked="true" v-model="pessoa.endereco_nro"
                                  data-vv-name="endereco_nro" class="form-control"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Bairro</label>
                        <input type="text" class="form-control" v-model="pessoa.bairro"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Complemento</label>
                        <input type="text" class="form-control" v-model="pessoa.complemento"/>
                    </div>
                </div>

                <div v-if="parseInt(pessoa.remetente)" class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Senha</label>
                        <input type="text" class="form-control" v-model="pessoa.observacao"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control" v-model="pessoa.email"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Segundo email</label>
                        <input type="email" class="form-control" v-model="pessoa.email2"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Terceiro email</label>
                        <input type="email" class="form-control" v-model="pessoa.email3"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <vc-pesquisa
                            :selecionado="pessoa.cidade"
                            @input="(cidade) => { pessoa.cidade_id = cidade.id}"
                            label="Cidade"
                            nome-input="cidade_id"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/cidades/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Código IBGE', 'campo' : 'codigo_ibge'}]"
                            obrigatorio="cidade">
                    </vc-pesquisa>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <button type="submit" class="btn btn-success">Salvar</button>&nbsp;
                        <button type="button" class="btn btn-danger" @click="exibeForm = !exibeForm">Cancelar</button>
                    </div>
                </div>
            </div>

        </div>

    </form>

</template>

<script>
    import VcPesquisa from '@/components/Form/Pesquisa'
    import VcMostraMensagemValidacao from '@/components/Form/MostraMensagemValidacao'
    import ValidaCpfCnpjCep from './service/valida_cpf_cnpj_cep'

    export default {
        components: {
            VcPesquisa,
            VcMostraMensagemValidacao
        },
        data() {
            return {
                renderForm: true,
                modo: null,
                exibeForm: false,
                pessoa: {
                    tipo: {label: 'Físico', value: '1'}
                }
            }
        },

        methods: {            
            verificaJaCadastrado(nomeCampo) {
                let executaAjax = false;
                let valor = this.pessoa[nomeCampo]

                if (nomeCampo == 'cpf' && valor.length == 14 && ValidaCpfCnpjCep.validaCPF(valor)) {
                    executaAjax = true
                } else if (nomeCampo == 'cnpj' && valor.length == 18 && ValidaCpfCnpjCep.validaCNPJ(valor)) {
                    executaAjax = true
                }

                if (!executaAjax) {
                    return;
                }

                this.$http.post('api/pessoas/verifica-pessoa-cadastrada', {
                    'nomeCampo': nomeCampo,
                    'valor': valor
                }).then((response) => {
                    if (response.data.id > 0 && response.data.id != this.pessoa.id) {
                        window.swal('Atenção', 'Pessoa já cadastrada.', 'warning')
                        return this.pessoa[nomeCampo] = '';
                    }
                })
            },

            armazenar() {

                this.$validator.validate().then(valid => {
                    if (!valid) {
                        return null;
                    }

                    let pessoa = this.pessoa;

                    pessoa.ativo = 1;
                    let tipoPreSave = pessoa.tipo;
                    pessoa.tipo = pessoa.tipo.value;

                    if (!pessoa.proprietarioArrendatario && !pessoa.remetente) {
                        return window.swal("Atenção", "Informe se a pessoa é proprietário ou remetente.", "warning")
                    }

                    let controlePromise = (promise) => {
                        promise.then(() => {
                            pessoa.tipo = tipoPreSave
                            window.swal("Sucesso", "Pessoa armazenada com sucesso!", "success")
                            this.exibeForm = false
                            this.$set(this, 'pessoa', {tipo: {label: 'Físico', value: '1'}})
                        }).catch((response) => {
                            return window.swal("Atenção", "Não foi possível armazenar a pessoa. " + response.message, "warning")
                        });
                    };

                    controlePromise(this.$http.post('api/pessoas', pessoa))
                });
            },

            async consultaCep () {
                let retorno = await ValidaCpfCnpjCep.consultaCep(this.pessoa.cep, this.$http)
                if (retorno !== null) {
                    this.$set(this.pessoa, 'endereco', retorno.logradouro)
                    this.$set(this.pessoa, 'bairro', retorno.bairro)
                    this.$set(this.pessoa, 'complemento', retorno.complemento)
                    this.$set(this.pessoa, 'cidade', retorno.cidade)
                }
            }
        }
    }
</script>

